import type { AppData } from './types';

export function validString(value: unknown): string | undefined {
	if (typeof value !== 'string') return undefined;
	const trimmed = value.trim();
	return trimmed &&
		trimmed !== 'null' &&
		trimmed !== 'undefined' &&
		!/[;\r\n]/.test(trimmed)
		? trimmed
		: undefined;
}

export function parseAuthToken(value: unknown): string | undefined {
	const token = validString(value);
	const normalized = token
		? validString(token.replace(/^Bearer(?:\s+|$)/i, ''))
		: undefined;
	return normalized && !/\s/.test(normalized) ? normalized : undefined;
}

export function parseAppData(value: unknown): AppData {
	const data: unknown = typeof value === 'string' ? JSON.parse(value) : value;
	if (!data || typeof data !== 'object' || Array.isArray(data)) return {};
	return Object.fromEntries(
		(
			[
				'clientId',
				'apiKey',
				'Authorization',
				'uuid',
				'appVersion',
				'deviceId',
			] as const
		).flatMap((key) => {
			const field = validString((data as Record<string, unknown>)[key]);
			return field ? [[key, field]] : [];
		}),
	);
}

export function consumeLaunchData(): AppData {
	const url = new URL(window.location.href);
	const data = parseAppData(Object.fromEntries(url.searchParams));
	if (url.searchParams.has('Authorization')) {
		// Preserve routing state, but don't leave credentials in logs/referrers.
		url.searchParams.delete('Authorization');
		window.history.replaceState(window.history.state, '', url);
	}
	return data;
}
